export default __webpack_public_path__ + "static/media/camra.23a95343.png";